import type { MarketClass, MarketRef } from './auto-slippage';
import { useIsShortRoundMarket } from '@/client/pages/btc-5m/use-rounds-feed';

/** Class of the traded market for the auto slippage. Unknown market data gives other. */
export const useMarketClass = (market: MarketRef | undefined): MarketClass => {
  const isShortRound = useIsShortRoundMarket();
  return market && isShortRound(market) ? 'short' : 'other';
};
